<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { SidebarProvider } from '@manta/ui-kit';
import AppSidebar from '@/components/Sidebar/AppSidebar.vue';
import SessionSidebar from '@/components/SessionSidebar.vue';

const route = useRoute();
const showSessionList = computed(() => route.meta.sessionList === true);
</script>

<template>
  <SidebarProvider class="h-screen w-screen overflow-hidden bg-background">
    <AppSidebar />
    <SessionSidebar v-if="showSessionList" />
    <main class="flex min-w-0 flex-1 flex-col overflow-hidden">
      <RouterView />
    </main>
  </SidebarProvider>
</template>
